import { useQuery } from "@apollo/client/react";
import type { InvoiceUploadUnitStatus } from "../../../models/InvoiceUploadUnitStatus";
import GET_INVOICE_UPLOAD_UNITS from "../../queries/documentHandler/getInvoiceUploadUnits";
import type { InvoiceUploadUnitModel } from "../../../models/InvoiceUploadUnitModel";
import type { SortDirection } from "../../../models/SortDirection";

type InvoiceUploadUnitResponseType = {
  invoiceUploadUnits: {
    totalCount: number;
    items: Array<InvoiceUploadUnitModel>;
  };
};

export const useInvoiceUploadUnits = (
  clientIdentifier: string,
  uploadUnitStatuses?: Array<InvoiceUploadUnitStatus>,
  skip?: number,
  take?: number,
  sortBy?: "CREATED_AT" | "STATUS",
  sortDirection?: SortDirection,
) => {
  const { data, error, loading, refetch } =
    useQuery<InvoiceUploadUnitResponseType>(GET_INVOICE_UPLOAD_UNITS, {
      variables: {
        uploadUnitStatuses: uploadUnitStatuses,
        clientIdentifier: clientIdentifier,
        skip: skip,
        take: take,
        sortBy: sortBy,
        sortDirection: sortDirection,
      },
      errorPolicy: "all",
    });
  return {
    uploadUnits: data?.invoiceUploadUnits,
    error,
    loading,
    refetch,
  };
};
